import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {useListStore} from '@components/common/sandbox/list-view/list-store'
import {Identifiable, RowConfig} from '@components/common/sandbox/list-view/types'

interface DoneCounterProps<TData> {
  rows?: RowConfig<TData>[],
  hideIfEmpty?: boolean
}

const TwContainer = tw.div`
  h-20 py-2 px-4 rounded-4 flex items-center gap-2 text-10 text-secondary bg-background-secondary border border-border-base mr-4 -ml-2
`

interface DoneCounterViewProps {
  doneCount: number,
  totalCount: number
}

export const DoneCounterView = (props: DoneCounterViewProps) => {
  const {doneCount, totalCount} = props

  return <TwContainer>
    <Icon icon="IconSubtask" />
    <div>
      {doneCount}/{totalCount}
    </div>
  </TwContainer>
}

export const DoneCounter = observer(<TData extends Identifiable>(props: DoneCounterProps<TData>) => {
  const {
    rows,
    hideIfEmpty
  } = props;
  const store = useListStore()
  const [stats, setStats] = useState(() => ({doneCount: 0, totalCount: 0}))
  useEffect(() => {
    if (!rows) {
      setStats({doneCount: 0, totalCount: 0})
      return;
    }
    const [done, total] = rows.reduce((acc, child) => {
      return [acc[0] + (store.isDone(child) ? 1 : 0), acc[1] + 1]
    }, [0, 0])
    setStats({doneCount: done, totalCount: total})
  }, [rows]);

  if (hideIfEmpty && stats.totalCount === 0) {
    return null
  }

  return <DoneCounterView doneCount={stats.doneCount} totalCount={stats.totalCount} />
})